<template>
  <div>
    <v-hover v-slot:default="{ hover }">
      <v-avatar width="100" height="100" class="pointer" @click="$refs.fileupload.click()">
        <v-img aspect-ratio="1" :src="petPhoto">
          <v-fade-transition>
            <div
              v-if="hover"
              class="d-flex flex-row-reverse align-end"
              style="height: 100%;width:100%;background:rgba(0, 0, 0, 0.56);"
            >
              <v-icon color="white" large>mdi-camera-outline</v-icon>
            </div>
          </v-fade-transition>
        </v-img>

        <v-icon
          :color="pet.gender === 'male' ? $classStyle.genderMale : $classStyle.genderFemale"
          x-large
          style="position: absolute;bottom: -34px;right: -34px; z-index:2"
          v-text="
                        pet.gender === 'male'
                          ? 'mdi-gender-male'
                          : 'mdi-gender-female'
                      "
        ></v-icon>
      </v-avatar>
    </v-hover>
    <input v-show="false" @change="upload" type="file" ref="fileupload" accept=".jpg, .jpeg, .png" />
  </div>
</template>
<script>
export default {
  data: () => ({
    hover: "",
    petPhoto: "",
    pet: ""
  }),
  methods: {
    async setAvatar(pet, forceReload) {
      this.pet = pet;
      let photoUrl = `${
        this.$config.apiUrl
      }/${this.$my.getClinic()}/photo/avatar/${pet._id}`;

      if (forceReload) {
        photoUrl += "?t=" + new Date().getTime();
      }

      try {
        let response = await this.$ajax.get(photoUrl);
        if (JSON.stringify(response.data) === "{}") {
          this.petPhoto = require(`../../assets/img_${this.pet.type}.png`);
        } else {
          this.petPhoto = photoUrl;
        }
      } catch (e) {
        this.petPhoto = require(`../../assets/img_${this.pet.type}.png`);
      }
    },
    async upload(event) {
      const photo = event.target.files.item(0);
      console.log("photo:" + photo);

      const dataForm = new FormData();
      dataForm.append("photo", photo);

      await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/photo/avatar/${
          this.pet._id
        }`,
        dataForm
      );

      await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/bot/socket`,
        {
          cmd: "updateAvatar",
          petId: this.pet._id,
          phone: this.pet.userPhone
        }
      );
    }
  }
};
</script>